import {
    NpcEventRel,
    SpendLogInfoI,
    SpendModeAccountBookItemI,
    SpendModeEventChooseI,
    SpendModeEventI
} from "../../config/SpendInterface";
import spendGameManager from "../../manager/spendGameManager";
import getOneSpendEventById from "../../config/SpendEventConfig";
import O1HD from "../../../../engines/gameEngine";
import investmentPage from "../../page/investmentPage";

const {ccclass, property} = cc._decorator;

/**
 * 投资 item
 */
@ccclass
export default class InvestmentItem extends cc.Component {

    @property({type:cc.Sprite,displayName:"npc icon"})
    npcIcon : cc.Sprite = null;
    @property({type:cc.Label,displayName:"npcName"})
    npcName : cc.Label = null;
    @property({type:cc.Label,displayName:"投资金额"})
    investCoinsLb : cc.Label = null;
    @property({type:cc.Label,displayName:"投资昨日描述"})
    yesterdayDescLb : cc.Label = null;
    @property({type:cc.Label,displayName:"投资金额"})
    remainCoinsLb : cc.Label = null;
    @property(cc.Node)
    btnInvestNode : cc.Node = null;

    @property({type:cc.Prefab,displayName:"追投弹窗"})
    investmentPage:cc.Prefab = null;

    //事件 实体
    private mEventEntity : SpendModeEventI;
    private mGameLayer : spendGameManager;
    private itemData : SpendModeAccountBookItemI;

    onLoad () {

    }

    start () {

    }

    /**
     * 绑定数据
     */
    bindData( itemData : SpendModeAccountBookItemI , gameLayer : spendGameManager , dayRecordFlag : boolean = false){
        //获取事件 实体
        this.mEventEntity = getOneSpendEventById( itemData.eventId );
        this.mGameLayer = gameLayer;
        let currDays = this.mGameLayer.getGameData()._gameDays;
        this.itemData = itemData;
        //加载npc头像
        // O1HD.getManagers().gameMgr.getCurrMode().bundle.load(`res/Image/npc/circleIcon/${this.mEventEntity.belongNpc}`,cc.SpriteFrame,( error, assets : cc.SpriteFrame )=>{
        //     if ( error ) {
        //         console.log("")
        //         return;
        //     }
        //     this.npcIcon.spriteFrame = assets;
        // });

        //npc 名称
        this.npcName.string = `${this.mEventEntity.belongNpc}`;

        let dataItem = this.mGameLayer.getGameData()._currentEvents.find(( item , index , dataList )=>{
            return item.npc == this.mEventEntity.belongNpc;
        })
        // 触发该选项的收益
        if ( dayRecordFlag ) {
            //如果是当日 报表进来的
            if ( itemData._income && itemData._income != 0 ){
                //如果当日盘口 金额有变动
                dataItem.remainCoins += itemData._income;
            }
            if ( itemData.userCoinChange && itemData.userCoinChange != 0 ) {
                this.mGameLayer.getGameData()._coin += itemData.userCoinChange;
                if ( itemData.userCoinChange > 0 ) {
                    //TODO 用户金钱变动特效
                }
            }
            this.mGameLayer.writeGameData();
        }

        this.investCoinsLb.string = `${dataItem.investCoins}`;
        this.yesterdayDescLb.string = `${ currDays == 0 ? "暂无消息" : itemData._dec}`;
        this.remainCoinsLb.string = `${dataItem.remainCoins}`;

        if ( currDays == 0 ) {
            this.btnInvestNode.active = false;
        }

        if ( itemData.chasingThrowCoins == 0 || dataItem.todayInvestCoins > 1 ) {
            this.btnInvestNode.active = false;
        }


    }

    /**
     * 追投
     */
    onBtnChasingInvestment( e , chooseDefine : string = "0"){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        let ip:cc.Node = cc.instantiate(this.investmentPage);
        let is :investmentPage = ip.getComponent(investmentPage);
        ip.setParent(O1HD.Canvas());
        is.bindData( this.itemData,this.mGameLayer,(flag)=>{
            if ( flag ) {
                console.log("触发一次>>>>")
                this.btnInvestNode.active = false;
                // 确认追投
                let chooseItem =  this.mEventEntity.chooseArr[ Number( chooseDefine ) ];

                //获取追投id  以及EventInfo 覆盖当天以后的所有 日志
                let chooseData:SpendModeEventChooseI = null;
                switch(chooseDefine){
                    case "0":{
                        chooseData = this.mEventEntity.chooseArr[0];
                        break;
                    }
                    case "1":{
                        chooseData = this.mEventEntity.chooseArr[1];
                        break;
                    }
                }
                let currDays = this.mGameLayer.getGameData()._gameDays;
                if ( chooseData.logInfo ) {
                    for ( let i = 0 ; i < chooseData.logInfo.length ; i ++ ) {
                        let logInfo : SpendLogInfoI = chooseData.logInfo[i];
                        let bookItemI : SpendModeAccountBookItemI = {
                            //npc
                            npc : this.mEventEntity.belongNpc,
                            //事件id
                            eventId : this.mEventEntity.id,
                            //日志内容描述
                            _dec: logInfo.desc,
                            //日志 影响数额
                            _income : logInfo.coinChange,
                            //追投描述
                            chasingThrowDesc : logInfo.chasingThrowDesc,
                            //追投金额
                            chasingThrowCoins : logInfo.chasingThrowCoin
                        };
                        if ( !this.mGameLayer.getGameData()._account_book[currDays+1] ) {
                            this.mGameLayer.getGameData()._account_book[currDays+1] = [];
                        }
                        this.mGameLayer.getGameData()._account_book[currDays+1].push( bookItemI );
                    }
                }

                // 更新今日花钱
                this.mGameLayer.getGameData()._currentCostMoney += chooseData.chooseParam.value;
                this.mGameLayer.writeGameData();
                // 投资金额
                O1HD.emit("spendGameManager.addOrUpdateEvent", this.itemData.npc ,this.itemData.eventId , -this.itemData.chasingThrowCoins , this.itemData.chasingThrowCoins );
                O1HD.emit("Page.refreshData");
            }else{
                //取消
            }
        });
    }


}
